export const SEEK_PLAYHEAD_TO_EVENT = 'seek-playhead-to';

export const seekPlayheadTo = (time: number): void => {
  window.dispatchEvent(new CustomEvent(SEEK_PLAYHEAD_TO_EVENT, { detail: { time } }));
};
